define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/xml"
], function(declare,Controller,xml) {

	return declare(Controller, {
		urlBatch: null,

		toWriterRequest: function(/*csi.action.FormData?*/fd) {
			var call = this.inherited(arguments);
			call.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, [this.urlBatch]);
		}
	});
});